import { render, staticRenderFns } from "./DevicesMenu.vue?vue&type=template&id=8b3857ce&scoped=true&"
import script from "./DevicesMenu.vue?vue&type=script&lang=js&"
export * from "./DevicesMenu.vue?vue&type=script&lang=js&"
import style0 from "./DevicesMenu.vue?vue&type=style&index=0&id=8b3857ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3857ce",
  null
  
)

export default component.exports